module.exports = {"id":"200463","name":"Tim Melia","rating":"74","photo":"./data/images/photos/0/200463.png","club":{"name":"Sporting KC","logo":"./data/images/clubs/SportingKC.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TimMelia0.json
// module id = 4134
// module chunks = 0